module.exports = __webpack_public_path__ + "7fe34c1e160dc851310c1a6469a8379a.svg";